export default __webpack_public_path__ + "static/media/pass.678a3c78.png";